import { AudioManager, AudioType } from '@colonist/audio';
import { setElementInnerText, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { CA } from '../analytics/Analytics.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
export class UIStoreMembershipTabsController {
    setTabAnnual(annual) {
        if (annual) {
            this.monthlyTab.classList.remove('active');
            this.annualTab.classList.add('active');
            return;
        }
        this.monthlyTab.classList.add('active');
        this.annualTab.classList.remove('active');
    }
    static getDiscountString() {
        const defaultYearlyDiscount = 20;
        return `${defaultYearlyDiscount}`;
    }
    constructor(storeState, monthlyTab, annualTab){
        this.monthlyTab = monthlyTab !== null && monthlyTab !== void 0 ? monthlyTab : document.getElementById('store_page_membership_monthly_tab');
        this.annualTab = annualTab !== null && annualTab !== void 0 ? annualTab : document.getElementById('store_page_membership_annual_tab');
        const discountString = UIStoreMembershipTabsController.getDiscountString();
        setElementInnerText(this.annualTab, {
            key: 'strings:storePage.membership.frequency.annual',
            options: {
                context: 'store',
                discount: `${discountString}`
            }
        });
        setElementOnClick(this.monthlyTab, ()=>{
            AudioManager.play(AudioType.Click);
            storeState.membershipToggleYearlyActive = false;
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.MonthlyYearlyToggleSwitched,
                category: AnalyticEventCategory.Store,
                stringValue: 'monthly'
            });
        });
        setElementOnClick(this.annualTab, ()=>{
            AudioManager.play(AudioType.Click);
            storeState.membershipToggleYearlyActive = true;
            void CA.sendAnalyticEvent({
                type: AnalyticEventType.MonthlyYearlyToggleSwitched,
                category: AnalyticEventCategory.Store,
                stringValue: 'yearly'
            });
        });
    }
}
